import { Search } from "react-bootstrap-icons";
import { components } from 'react-select';
const CustomPlaceholder = (props: any) => {
    return (
        <components.Placeholder {...props}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Search style={{ marginRight: '5px' }} />
                <span>Search</span>
            </div>
        </components.Placeholder>
    );
};

export const customStyles = {
    placeholder: (provided: any) => ({
        ...provided,
        display: 'flex',
        alignItems: 'center',
        color: '#999',
    }),
};

export default CustomPlaceholder;